import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-chart-line1-icon',
  templateUrl: './shopping-chart-line1.component.html'
})
export class ShoppingChartLine1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
